import React, { useEffect, useState } from "react";
import { Card, Table, Tooltip, Button, } from "antd";
import { SelectOutlined } from "@ant-design/icons";
import { setFormFieldValue } from "../../../../../helpers/FormHelper";
import { EmptyTable } from "../../../../Election/Patronage/PatronageReferred/voters-list/components/List";
import ErrorCard from "../../../../../components/Common/Cards/ErrorCard";
import moment from "moment";



const List = ({ dispatch, items, totalCount, initialPagination, loading, errorMessage, setLoadingType, selectVoter }) => {
    const [paginationTable, setPaginationTable] = useState({
        showSizeChanger: false,
        pageSizeOptions: [5, 10, 15, 20, 25],
        pageSize: initialPagination.pageSize,
        current: initialPagination.currentPage,
        total: totalCount,
        showTotal: (total, range) => `${range[0]}-${range[1]} nga ${total} `,
    });


    useEffect(() => {
        setPaginationTable({
            showSizeChanger: false,
            pageSizeOptions: [5, 10, 15, 20, 25],
            pageSize: initialPagination.pageSize,
            current: initialPagination.currentPage,
            total: totalCount,
            showTotal: (total, range) => `${range[0]}-${range[1]} nga ${total} `,
        });
    }, [initialPagination, totalCount]);


    const handleTableChange = (pagination, filters, sorter) => {
        setLoadingType(null);
        const action = {
            type: "set_table_pagination",
            payload: {
                pageSize: pagination.pageSize,
                currentPage: pagination.current,
            },
        };
        dispatch(action);
    };


    const tableColumns = [
        {
            title: "#",
            dataIndex: "row_number",
            key: "row_number",
            width: 70,
            align: "center",
            render: (value) => <b>{value + "."}</b>,
        },
        {
            title: "Emri",
            dataIndex: "name",
            align: 'left',
            width: 150,
            render: (_, elm) => setFormFieldValue(elm?.name)
        },
        {
            title: "Mbiemri",
            dataIndex: "surname",
            align: 'left',
            width: 150,
            render: (_, elm) => setFormFieldValue(elm?.surname)
        },
        {
            title: "Atësia",
            dataIndex: "father_name",
            align: 'left',
            width: 150,
            render: (_, elm) => setFormFieldValue(elm?.father_name)
        },
        {
            title: "Datëlindja",
            dataIndex: "dob",
            align: 'center',
            width: 130,
            render: (_, elm) => moment(elm?.dob).format("DD-MM-YYYY")
        },
        {
            title: "Qarku",
            dataIndex: "region",
            align: 'left',
            width: 180,
            render: (_, elm) => setFormFieldValue(elm?.region?.name)
        },
        {
            title: "Bashkia",
            dataIndex: "municipality",
            align: 'left',
            width: 220,
            render: (_, elm) => setFormFieldValue(elm?.municipality?.name)
        },
        {
            title: "Nj. administrative",
            dataIndex: "unit",
            align: 'left',
            width: 260,
            render: (_, elm) => setFormFieldValue(elm?.unit?.name)
        },
        {
            title: "Zgjidh",
            dataIndex: "actions",
            align: "center",
            width: 90,
            fixed: "right",
            className: "bg-white m-0 p-0",
            render: (_, elm) => (
                <div className="p-2" style={{ backgroundColor: "#fff" }}>
                    <Tooltip title="Zgjidh">
                        <Button
                            type="primary"
                            onClick={() => selectVoter(elm)}
                            icon={<SelectOutlined />}
                        />
                    </Tooltip>
                </div>
            ),
        },
    ];


    return (
        <Card style={{ borderRadius: "0", marginBottom: '0' }} bodyStyle={{ padding: "0" }}>
            <div className="table-responsive">
                <Table
                    size="small"
                    className="striped-table"
                    columns={tableColumns}
                    rowKey="id"
                    loading={loading}
                    dataSource={items}
                    pagination={paginationTable}
                    onChange={handleTableChange}
                    scroll={{ x: 800 }}
                    showHeader="true"
                    locale={{
                        emptyText: errorMessage ? (
                            <ErrorCard message={errorMessage} />
                        ) : (
                            EmptyTable
                        ),
                    }}
                />
            </div>
        </Card>
    );
};

export default List;
